import httpClient from '../http_client/http_client';
import ContractEntity from '../../entities/contract/contract_entity';
import INewContractRequestBody from "../../interfaces/inew_contract_request_body";

export class ContractHttpRequests {
   create: Function = (
      requestBody: INewContractRequestBody,
      callbacks: {
         success: Function,
         failure: Function
      }) => {
      httpClient.request({
         method: 'post',
         url: 'v1/contracts',
         data: {
            plan: requestBody.plan,
            name: requestBody.name,
            expires: requestBody.expires
         }
      }, {
         success: (response: any) => {
            const contract = new ContractEntity(response.data);
            callbacks.success(contract);
         },
         failure: (error: any) => {
            callbacks.failure(error);
         }
      });
   };
   addUser: Function = (
      contractId: string,
      userId: string,
      callbacks: {
         success: Function,
         failure: Function
      }) => {
      httpClient.request({
         method: 'post',
         url: `v1/contracts/${contractId}/users`,
         data: {
            user_id: userId
         }
      }, {
         success: (response: any) => {
            callbacks.success('User added');
         },
         failure: (error: any) => {
            callbacks.failure(error);
         }
      });
   };
}

const contractHttpRequestInstance = new ContractHttpRequests();

export default contractHttpRequestInstance;
